// extracted by mini-css-extract-plugin
module.exports = {"searcher":"styles_searcher__2OSle"};